const BetTypes = {
    Winner : 1,
    Score:2,
    Champion: 3,
    RunnerUp: 4,
};

export default BetTypes;